// Helper function to check if two rectangles overlap
export const isRectsOverlapping = (rect1: DOMRect, rect2: DOMRect) => {
    const isOverlapping =
        rect1.right >= rect2.left &&
        rect1.left <= rect2.right &&
        rect1.bottom >= rect2.top &&
        rect1.top <= rect2.bottom;

    return isOverlapping;
};
